import { Component, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { IActivityBankReport } from '@core/interfaces/iactivity-bank-report';
import { ActivityBankService } from '@core/services/activity-bank.service';
import { TranslocoService } from '@jsverse/transloco';
import { take } from 'rxjs';

@Component({
  selector: 'drdp-activity-bank-results',
  standalone: false,
  templateUrl: './activity-bank-results.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './activity-bank-results.component.scss'
})
export class ActivityBankResultsComponent {
  @Input() reportData: IActivityBankReport[] = [];  
  @Input() isParentProgressActivities: boolean = false;
  selectedStudent: number | null = null;

  private activityBankService = inject(ActivityBankService);
  private translocoService = inject(TranslocoService);

  domainClass(domainCode: string): string {
    return domainCode == "COG:MATH" || domainCode == "COG:SCI" || domainCode == "MATH" || domainCode == "SCI" ? "cog" : domainCode.toLowerCase();
  }

  changeStudentShow(enrollmentId: number): void {
    if (this.selectedStudent === enrollmentId) {
      this.selectedStudent = null;
      return;
    }

    this.selectedStudent = enrollmentId;
  }

  onSave(student: IActivityBankReport): void {
    const selected: number[] = [];

    student.domains.forEach(domain => {
      domain.measures.forEach(measure => {
        measure.activities.forEach(activity => {
          if (activity.isSelected && activity.activityBankId)
            selected.push(activity.activityBankId);
        });
      });
    });

    this.activityBankService.updateChildActivitySelections(
      [{ enrollmentId: student.enrollmentId, activityBankIds: selected, isParentProgressActivities: this.isParentProgressActivities }],
      this.translocoService.translate('reports.activities.savedForChildToast', { name: `${student.firstName} ${student.lastName}` })
    ).pipe(take(1)).subscribe();
  }
}
